import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getSummaryReport } from "./Services";


export const useGetSummaryReports = (filter:any) => {
  const query = useQuery(
    [endpoints.getSummaryReport,filter],
    () => {
      return getSummaryReport(filter);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};
